<div class="container">
    <h3>{{ 'Autenticação em andamento' | translate }}</h3>
    <p>{{ 'Favor aguardar' | translate }}</p>
</div>